import React, { useEffect, useRef } from 'react'
import { useParallax } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';
import HomeVideo from '../../assets/images/check-video.mp4';


export default function Hardening() {
    const swiperRef1 = useRef();

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>

            <section className="inner-banner" style={{ position: 'relative', overflow: 'hidden' }}>
                <video
                    autoPlay
                    loop
                    muted
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: -1,
                    }}
                >
                    <source src={HomeVideo} type="video/mp4" />
                </video>
                <h1 className='heading'>Server Hardening</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li className="breadcrumb-item"><Link to="#">Home</Link></li>
                        <li className='star'><i className="fa fa-arrow-right"></i></li>
                        <li className="breadcrumb-item"><Link to="/services">Services</Link></li>
                        <li className='star'><i className="fa fa-arrow-right"></i></li>
                        <li className="breadcrumb-item active" aria-current="page">Server Hardening</li>
                    </ol>
                </nav>
            </section>

            <section className='about-section-4 bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='header-title mb-40px'>
                                <h3 className='heading wow fadeInUp' >Server Hardening</h3>
                                <p className='paragraph'>Server hardening is a comprehensive process aimed at enhancing the security of a server by implementing advanced protective measures across various layers, including hardware, firmware, and software. This involves configuring settings, managing permissions, and securing data, ports, and components to minimize vulnerabilities and protect against unauthorized access and potential threats. By adopting a systematic approach to server hardening, organizations can significantly reduce their risk profile and strengthen their overall cybersecurity posture.</p>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='service-left-image'>
                                <img src={require('../../assets/images/services/server-handling.webp')} alt='' />
                            </div>
                        </div>
                    </div>
                    <div className="row top">
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/depth-perception.webp')} alt="anytime" />
                                <h2>Depth</h2>
                                <p>Our hackers go in depth to find vulnerabilities in your system.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/service.webp')} alt="Mobile Application Development" />
                                <h2>Standards</h2>
                                <p>We use industry standard tools to find even the bad loopholes.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/receipt.webp')} alt="Mobile App Development Services " />
                                <h2>Report</h2>
                                <p>Get a penetration testing report that's written in layman language.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/comment.webp')} alt="Mobile App Development Services " />
                                <h2>Good News</h2>
                                <p>Yes, your free consultation is just a click away.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='achievement-section top bottom' style={{ background: '#101218' }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='stories-section'>
                                <img src={require('../../assets/images/services/hardling/server-hardling.webp')} alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='more-services mb-0' >
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='header-title mb-40px top'>
                                <h3 className='heading wow fadeInUp' >Listen to People</h3>
                                <p className='paragraph'>We help companies to protect their online assets.</p>
                                <p className='paragraph'>Cyber Fortify team took barely 3 days to figure out the issues I had on my application. Their team consistently worked with my developer team to build a security system for my application which deals with sensitive data. Thank you team for your genius work.</p>
                            </div>
                        </div>
                        <div className='col-lg-6 mb-40px top service-more-detials'>
                            <div className="cards">
                                <div className='box-text'>
                                    <h4 className='heading'>Explore More Services</h4>
                                    <p className='paragraph'>"Discover comprehensive cybersecurity solutions to safeguard your digital assets today."</p>
                                    <div className='services-button'>
                                        <Link to="/services">
                                            <button className='btn footer-btn btn-class'>More Services<span>More Services</span></button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row top">
                        <div className='header-title text-center'>
                            <h2 className='heading wow fadeInUp'>Types of System Hardening Services We Offer</h2>
                            <p className='paragraph wow fadeInUp' style={{ color: '#e0dcdc' }}>Comprehensive VAPT Solutions Tailored to Your Security Needs</p>
                        </div>
                        <div className="col-lg-6">
                            <div className="software-develop-cyber appbenefits">
                                <img src={require('../../assets/images/services/hardling/1.webp')} alt="" />
                                <h2>Software Application Hardening</h2>
                                <p className='paragraph wow fadeInUp'>The process of updating or installing additional security measures to protect both standard and third-party applications on your server is known as application hardening. This practice enhances the security posture of applications by addressing vulnerabilities and implementing safeguards to mitigate potential risks.</p><br />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="software-develop-cyber appbenefits">
                                <img src={require('../../assets/images/services/hardling/2.webp')} alt="anytime" />
                                <h2>Operating system hardening</h2>
                                <p className='paragraph wow fadeInUp'>Operating system hardening (OS hardening) secures a server's OS through patching and advanced security measures. Automating the installation of updates, patches, and service packs effectively addresses vulnerabilities, enhancing the overall security and resilience of the operating system against potential threats.</p><br />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="software-develop-cyber appbenefits">
                                <img src={require('../../assets/images/services/hardling/3.webp')} alt="" />
                                <h2>Network hardening</h2>
                                <p className='paragraph wow fadeInUp'>Network hardening protects the communication infrastructure of interconnected servers and systems. It relies on intrusion prevention systems (IPS) and intrusion detection systems (IDS) to monitor suspicious activity, helping administrators identify threats and prevent unauthorized access, thereby enhancing overall network security.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="software-develop-cyber appbenefits">
                                <img src={require('../../assets/images/services/hardling/4.webp')} alt="anytime" />
                                <h2>Database Hardening</h2>
                                <p className='paragraph wow fadeInUp'>Database hardening secures the contents of a digital database its management system (DBMS). This process protects sensitive information enhances resilience against unauthorized access and potential threats, ensuring that data remains secure and the system functions reliably.</p><br />
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </section>

            <section className='faq-section-b bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
                <div className='container'>
                    <h2 className='heading text-center text-dark' style={{ fontWeight: 'bold' }}>Frequently Asked Questions</h2>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='service-detail-left-side'>
                                <div className='faq-section-inner'>
                                    <div class="accordion wow fadeInUp" id="accordionExample">
                                        <div className='faq-box'>

                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        How does consumer marketing differ from other forms of marketing?
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        Consumer marketing focuses specifically on understanding and targeting individual consumers, whereas other forms of marketing may target businesses or broader market segments.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                        What strategies does Brand Street use to engage consumers?
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We utilize a variety of strategies including targeted messaging, personalized experiences, influencer partnerships, and interactive content to engage consumers and drive brand affinity.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                        How does Brand Street ensure that its consumer marketing campaigns resonate with target audiences?
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We conduct thorough audience research and employ data-driven insights to tailor our campaigns to the unique preferences and behaviors of our target audience.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                        Can Brand Street help with both B2C and B2B consumer marketing?
                                                    </button>
                                                </h2>
                                                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        Yes, we have experience working with clients in both B2C and B2B industries, developing customized strategies to effectively reach and engage their respective target audiences.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                        What types of consumer marketing channels does Brand Street utilize?
                                                    </button>
                                                </h2>
                                                <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We leverage a mix of traditional and digital channels including social media, email marketing, content marketing, experiential activations, and influencer partnerships to reach and engage consumers across multiple touchpoints.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
